import { render } from "./ProductReportEntranceExit.vue?vue&type=template&id=1a54b05a"
import script from "./ProductReportEntranceExit.vue?vue&type=script&lang=js"
export * from "./ProductReportEntranceExit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__